import type { FieldProps } from 'formik';

import { Checkbox as ChakraCheckbox, Skeleton } from '@frontend/components';

import { useFeatureFlagFormContext } from 'modules/common/drawers/featureFlagDrawer/components/FormWrapper/FeatureFlagFormContext';
import {
  FeatureFlagData,
  FeatureFlagType,
} from 'modules/common/drawers/featureFlagDrawer/types';

export const CheckboxInput = ({
  field,
}: FieldProps<boolean> & {
  flagData: Extract<FeatureFlagData, { type: FeatureFlagType.Boolean }>;
}) => {
  const {
    featureFlagsQueryResult: { isLoading },
  } = useFeatureFlagFormContext();

  const { name: fieldName, value: fieldValue, onBlur, onChange } = field;

  if (!fieldName) {
    return null;
  }

  return (
    <Skeleton
      isLoaded={!isLoading}
      height={2}
      display="flex"
      flexDirection="row"
      alignItems="center"
      justifyContent="center"
    >
      <ChakraCheckbox
        name={fieldName}
        onBlur={onBlur}
        onChange={onChange}
        isChecked={Boolean(fieldValue)}
        sx={{
          '.chakra-checkbox__control': {
            my: 0,
          },
        }}
      />
    </Skeleton>
  );
};
